'use client';

import { Sidebar } from '..';

export function AppLayout({ children, purchasedPacks, selectedPack, onPackChange, withOldComponent = false }) {
  return (
    <div className="flex relative bg-[var(--q3-surface-default)] min-h-screen w-full z-50">
      <div className="flex-shrink-0 sm:w-0 lg:w-[100px]">
        <Sidebar
          withOldComponent={withOldComponent}
          purchasedPacks={purchasedPacks}
          selectedPack={selectedPack}
          onPackChange={onPackChange}
        />
      </div>
      <div className="flex-1 min-w-0 overflow-hidden flex justify-center">{children}</div>
    </div>
  );
}
